import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(VSimpleTable, {
    staticClass: "elevation-0 mb-4",
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function () {
          return [
            _c("thead", [
              _c("tr", [
                _c("th", [_vm._v("Nº")]),
                _c("th", [_vm._v("SERVIDOR")]),
                _c("th", { staticClass: "text-center" }, [
                  _vm._v(
                    _vm._s(
                      `${_vm.itemA.letra}. ${_vm.itemA.descricao}`.toUpperCase()
                    )
                  ),
                ]),
                _c("th", { staticClass: "text-center" }, [
                  _vm._v(
                    _vm._s(
                      `${_vm.itemB.letra}. ${_vm.itemB.descricao}`.toUpperCase()
                    )
                  ),
                ]),
              ]),
            ]),
            _c(
              "tbody",
              _vm._l(_vm.respostas, function (resposta, index) {
                return _c("tr", { key: resposta.id }, [
                  _c("td", [
                    _c("span", { staticClass: "grey--text text--darken-2" }, [
                      _vm._v(_vm._s(++index)),
                    ]),
                  ]),
                  _c("td", [
                    _c("span", { staticClass: "grey--text text--darken-2" }, [
                      _vm._v(_vm._s(resposta.servidor)),
                    ]),
                  ]),
                  _c(
                    "td",
                    { staticClass: "text-center" },
                    [
                      _c(VIcon, { attrs: { color: "grey" } }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.getCheckBoxIcon(
                                resposta.itemEscolhido,
                                _vm.itemA
                              )
                            ) +
                            " "
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "td",
                    { staticClass: "text-center" },
                    [
                      _c(VIcon, { attrs: { color: "grey" } }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.getCheckBoxIcon(
                                resposta.itemEscolhido,
                                _vm.itemB
                              )
                            ) +
                            " "
                        ),
                      ]),
                    ],
                    1
                  ),
                ])
              }),
              0
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }